<template>
  <v-container :style="{ maxWidth: '1000px' }">
    <h3 class="headline mb-3">{{ $t('message_template.message_template_after_order_summary') }}</h3>
    <p>{{ $t('message_template.description') }}</p>
    <v-layout wrap :style="{ margin: '-0.5rem' }">
      <v-flex xs12 md6 class="pa-2">
        <h4 class="title mb-3">{{ $t('message_template.order_confirmation_message') }}</h4>
        <ViewCartSummaryViewer />
        <MessageTemplateConfigIframe
          :key="messageTemplateSettingKey"
          type="confirm_order"
          :style="{ height: '50rem' }"
        />
      </v-flex>
      <v-flex xs12 md6 class="pa-2">
        <h4 class="title mb-3">{{ $t('message_template.payment_confirmation_message') }}</h4>
        <ViewReceiptViewer />
        <MessageTemplateConfigIframe
          :key="messageTemplateSettingKey"
          type="order_summary"
          :style="{ height: '50rem' }"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewReceiptViewer from '@/components/elements/ViewReceiptViewer'
import MessageTemplateConfigIframe from './MessageTemplateConfigIframe'

export default {
  components: {
    ViewCartSummaryViewer,
    ViewReceiptViewer,
    MessageTemplateConfigIframe
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PaymentMessageTemplateAfterSummary.vue